var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mastery-heading-container"},[_c('img',{attrs:{"src":_vm.$store.getters['app/appLogo'],"alt":"","role":"presentation"}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.name)+" "+_vm._s(_vm.$store.getters['app/appName']))])])
}
var staticRenderFns = []

export { render, staticRenderFns }